<template>
<div id="page-login" class="container text-center">
    <div class="gradient-overlay"></div>
    <div class="content row">
        <div class="col-sm-12">
            <h1><b>Sound</b>Feed</h1>
            <h2>&mdash; REGISTER &mdash;</h2>
        </div>

        <div class="col-sm-12 form-container" v-if="!success">
            <div class="input-field email-field">
                <input v-model="email" @keyup.enter="register" id="email" type="text" class="text-input" autocomplete="off">
                <label for="email" id="email-label" :data-error="getError('email')" class="input-label active">{{ emailLabel }}</label>
            </div><br>

            <div v-show="!loading" @click="register" class="btn btn-block btn-login">REQUEST ACCOUNT</div>
            <div v-show="loading" class="btn btn-block btn-loading disabled">
                <loader color="ripple-light" size="128px"></loader>
            </div>
        </div>

        <div class="col-sm-12 form-container" v-else>
            <br><br><br>
            <span class="white-text">Your request was sent. Expect a response from us soon.</span>
            <br><br><br>
        </div>

        <div class="col-sm-12 row">
            <br><br><br>
            <router-link tag="div" to="/login" class="btn btn-block btn-register">BACK TO LOGIN</router-link>
        </div>        
    </div>
 
</div>
</template>

<script>
export default {
    components: {
        'loader': require('@/components/Loader.vue').default,
    },

    data() {
        return {
            email: '',
            emailLabel: 'Enter your email to request a Soundfeed account',
            errors: [],
            loading: false,
            success: false,
        }
    },

    methods: {
        register() {
            this.loading = true;
            this.$http.post(this.registerEndpoint, this.newUserDetails).then((success) => {
                this.loading = false;
                this.success = true;

                if (App.allowGtag) gtag('event', 'register', {
                    'event_category' : 'engagement',
                    'event_label' : 'Request account'
                });                
            }, (error) => {
                this.loading = false;
                this.errors = error.data;
            });
        },

        inputClass(input) {
            if (this.hasError(input)) {
                return 'validate invalid';
            }
        },

        hasError(input) {
            return typeof this.errors[input] !== 'undefined';
        },

        getError(input) {
            if (!this.hasError(input)) {
                return '';
            }
            return this.errors[input][0];
        },
    },

    computed: {
        registerButtonText() {
            if (this.loading) {
                return 'Loading...';
            }

            return 'Request an account';
        },

        registerEndpoint() {
            return App.restApi + '/api/registration-request';
        },

        newUserDetails() {
            return {
                email: this.email,
            }
        },
    },

    watch: {
        errors(errorMessages) {
            if (this.hasError('email')) {
                $('#email').addClass('validate')
                    .removeClass('valid')
                    .addClass('invalid');
            }
        },
    }
}
</script>
